import { render, staticRenderFns } from "./ObjectImagesFull.vue?vue&type=template&id=7c971582"
import script from "./ObjectImagesFull.vue?vue&type=script&lang=js"
export * from "./ObjectImagesFull.vue?vue&type=script&lang=js"
import style0 from "./ObjectImagesFull.vue?vue&type=style&index=0&id=7c971582&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports